import ServerDirections from '@/config/server-directions'
import { Currency } from '@/entities/Currency'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class CurrencyRequests {
  list () {
    const route = ServerDirections.CURRENCIES
    const method = 'get'
    function map (data) {
      return data.map(item => new Currency(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
  postpaid (accountId, currencyId) {
    const route = ServerDirections.ACCOUNTS_ID_CURRENCIES_ID.replace('{accountId}', accountId).replace('{currencyId}', currencyId)
    const method = 'put'
    const body = { 'postpaid': true }
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, { body }, map)
  }
}
